import React, { useMemo } from "react"
import { Tab, Tabs } from "@mui/material"
import { styled } from "@mui/material/styles"
import BgImageTab from "@/assets/images/wavy.png"
import colors from "@/constants/colors"

const LendingTabs = styled(Tabs)({
  backgroundImage: `url(${BgImageTab.src})`,
  "& .Mui-selected": {
    color: `${colors.primary.orange} !important`,
  },
})

const PoolHeader = () => {
  const tabs = useMemo(() => {
    return [
      { label: "Main Pool", value: "main-pool" },
      // { label: "TRUNK/USDC Pool", value: "trunk-usdc-pool" },
      // { label: "TURBO SOL Pool", value: "turbo-sol-pool" },
      // { label: "Others", value: "others" },
    ]
  }, [])

  if (tabs.length <= 1) return <></>

  return (
    <LendingTabs
      value='main-pool'
      // onChange={handleChange}
      aria-label='lending-pool-tabs'
      TabIndicatorProps={{ className: "bg-orange-600" }}
      variant='scrollable'
      data-testid='lending-pool-tabs-header'
    >
      {tabs.map((tab) => (
        <Tab key={tab.value} value={tab.value} label={tab.label} />
      ))}
    </LendingTabs>
  )
}

export default PoolHeader
